import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import {
    accountingNavigation,
    administrationingNavigation,
    compactNavigation,
    defaultNavigation,
    futuristicNavigation,
    gateNavigation,
    consignmentNavigation,
    checklistsNavigation,
    qualityNavigation,
    hrNavigation,
    essNavigation,
    horizontalNavigation,
    inventoryNavigation,
    logisticsNavigation,
    manufacturingNavigation,
    posNavigation,
    procurementNavigation,
    opsNavigation,
    purchasesNavigation,
    salesNavigation,
    commissionNavigation,
    serviceBillingNavigation,
    commodityNavigation,
    digitalInvoicingNavigation,
    settingsNavigation,
    supportNavigation,
    supportCenterNavigation,
    treasuryNavigation,
    hospitalityNavigation,
} from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    private readonly _compactNavigation: FuseNavigationItem[] =
        compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] =
        defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] =
        futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] =
        horizontalNavigation;
    private readonly _accountingNavigation: FuseNavigationItem[] =
        accountingNavigation;
    private readonly _treasuryNavigation: FuseNavigationItem[] =
        treasuryNavigation;
    private readonly _adminNavigation: FuseNavigationItem[] =
        administrationingNavigation;
    private readonly _settingsNavigations: FuseNavigationItem[] =
        settingsNavigation;
    private readonly _inventoryNavigation: FuseNavigationItem[] =
        inventoryNavigation;
    private readonly _procurementNavigation: FuseNavigationItem[] =
        procurementNavigation;
    private readonly _opsNavigation: FuseNavigationItem[] =
        opsNavigation;
    private readonly _purchasesNavigation: FuseNavigationItem[] =
        purchasesNavigation;
    private readonly _salesNavigation: FuseNavigationItem[] =
        salesNavigation;
    private readonly _commissionNavigation: FuseNavigationItem[] =
        commissionNavigation;
    private readonly _serviceBillingNavigation: FuseNavigationItem[] =
        serviceBillingNavigation;
    private readonly _digitalInvoicingNavigation: FuseNavigationItem[] =
        digitalInvoicingNavigation;
    private readonly _commodityNavigation: FuseNavigationItem[] =
        commodityNavigation;
    private readonly _manufacturingNavigation: FuseNavigationItem[] =
        manufacturingNavigation;
    private readonly _hrNavigation: FuseNavigationItem[] =
        hrNavigation;
    private readonly _essNavigation: FuseNavigationItem[] =
        essNavigation;
    private readonly _logisticsNavigation: FuseNavigationItem[] =
        logisticsNavigation;
    private readonly _gateNavigation: FuseNavigationItem[] =
        gateNavigation;
    private readonly _consignmentNavigation: FuseNavigationItem[] =
        consignmentNavigation;
    private readonly _checklistsNavigation: FuseNavigationItem[] =
        checklistsNavigation;
    private readonly _qualityNavigation: FuseNavigationItem[] =
        qualityNavigation;
    private readonly _posNavigation: FuseNavigationItem[] =
        posNavigation;
    private readonly _hospitalityNavigation: FuseNavigationItem[] =
        hospitalityNavigation;
    private readonly _supportNavigation: FuseNavigationItem[] =
        supportNavigation;
    private readonly _supportCenterNavigation: FuseNavigationItem[] =
        supportCenterNavigation;
    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService.onGet('api/common/navigation').reply(() => {
            // Fill compact navigation children using the default navigation
            this._compactNavigation.forEach((compactNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === compactNavItem.id) {
                        compactNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            // Fill futuristic navigation children using the default navigation
            this._futuristicNavigation.forEach((futuristicNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === futuristicNavItem.id) {
                        futuristicNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            // Fill horizontal navigation children using the default navigation
            this._horizontalNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._accountingNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._treasuryNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._adminNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._settingsNavigations.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._inventoryNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._purchasesNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._salesNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._commissionNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._serviceBillingNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._digitalInvoicingNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._commodityNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._manufacturingNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._hrNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._essNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._logisticsNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._gateNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._consignmentNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._checklistsNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._qualityNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._posNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._supportNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            this._supportCenterNavigation.forEach((horizontalNavItem) => {
                this._defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });
            // Return the response
            return [
                200,
                {
                    compact: cloneDeep(this._compactNavigation),
                    default: cloneDeep(this._defaultNavigation),
                    futuristic: cloneDeep(this._futuristicNavigation),
                    horizontal: cloneDeep(this._horizontalNavigation),
                    accounting: cloneDeep(this._accountingNavigation),
                    treasury: cloneDeep(this._treasuryNavigation),
                    admin: cloneDeep(this._adminNavigation),
                    settings: cloneDeep(this._settingsNavigations),
                    inventory: cloneDeep(this._inventoryNavigation),
                    purchases: cloneDeep(this._purchasesNavigation),
                    procurement: cloneDeep(this._procurementNavigation),
                    trading: [],
                    ops: cloneDeep(this._opsNavigation),
                    sales: cloneDeep(this._salesNavigation),
                    commission: cloneDeep(this._commissionNavigation),
                    serviceBilling: cloneDeep(this._serviceBillingNavigation),
                    digitalInvoicing: cloneDeep(this._digitalInvoicingNavigation),
                    commodity: cloneDeep(this._commodityNavigation),
                    manufacturing: cloneDeep(this._manufacturingNavigation),
                    hr: cloneDeep(this._hrNavigation),
                    ess: cloneDeep(this._essNavigation),
                    logistics: cloneDeep(this._logisticsNavigation),
                    gate: cloneDeep(this._gateNavigation),
                    consignment: cloneDeep(this._consignmentNavigation),
                    checklists: cloneDeep(this._checklistsNavigation),
                    quality: cloneDeep(this._qualityNavigation),
                    pos: cloneDeep(this._posNavigation),
                    hospitality: cloneDeep(this._hospitalityNavigation),
                    support: cloneDeep(this._supportNavigation),
                    supportCenter: cloneDeep(this._supportCenterNavigation),
                },
            ];
        });
    }
}
